// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { filecoinCalibration as _filecoinCalibration } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the filecoinCalibration chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 314159
 * Chain Name: Filecoin Calibration
 * Default Block Explorer: https://calibration.filscan.io
 * Default RPC URL: https://api.calibration.node.glif.io/rpc/v1
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { filecoinCalibration } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: filecoinCalibration,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const filecoinCalibration = createCommon({
	..._filecoinCalibration,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
